// Meeting notes (FR-M6) as the notes screen renders them. F1 (notes generation) produces this
// shape; until it lands there is no endpoint and no data, and the screen shows its honest empty
// state. FR-M7: every generated line carries the transcript position it came from, and a line
// without one is never shown — so `t` is required, not optional.

/** A position in the recording, seconds. */
export type SourceTime = number;

export interface NotesSentence {
  text: string;
  t: SourceTime;
}

export interface NotesActionItem {
  text: string;
  t: SourceTime;
  owner?: string;
  due?: string;
  done?: boolean;
}

export interface MeetingNotes {
  /** Which AI account produced these (DS: name the account behind every output). */
  producedBy: string;
  summary: NotesSentence[];
  decisions: NotesSentence[];
  actions: NotesActionItem[];
}

/** F1 replaces this with the notes API. There is nothing to fetch yet, so there is no request. */
export async function loadMeetingNotes(_grackleId: string): Promise<MeetingNotes | null> {
  return null;
}
